import { Menu, Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { getMenu } from "../../../redux/menu/menuDucks";

import "./MenuApirante.css";

/**
 * Component que muestra el menú principal del aspirante
 * @param {*} props
 * @return {*} Menú Aspirante
 */
const MenuAspirante = (props) => {
  const dispatch = useDispatch();
  const { menu, loading, messageError } = useSelector((state) => state.menu);
  const { estatusAcceso } = useSelector((store) => store.usuarioLogin);

  useEffect(() => {
    dispatch(getMenu());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onMenuChange = (pathSubmodulo) => {
    props.history.push(`/admin/${pathSubmodulo}`);
    // setLocation(pathSubmodulo);
  };

  return (
    <Spin spinning={loading}>
      <Menu
        mode="horizontal"
        style={{
          textAlign: "center",
          backgroundColor: "#9159CB",
          color: "#fff",
          fontSize: 16,
          fontWeight: 300,
          borderTop: "1px solid #a1a1a1",
        }}
        hidden={estatusAcceso !== "1"}
      >
        {messageError ? (
          <Menu.Item key={"-1"} title={messageError}></Menu.Item>
        ) : (
          menu.map((modulo) =>
            modulo.listSubModulos.map(
              ({ idSubModulo, descripcionSubModulo, pathSubModulo }) => (
                <Menu.Item
                  key={modulo.idModulo + "|" + idSubModulo}
                  onClick={() => onMenuChange(pathSubModulo)}
                >
                  {descripcionSubModulo}
                </Menu.Item>
              )
            )
          )
        )}
        {/* {messageError ? (
          <Menu.SubMenu key={"-1"} title={messageError}></Menu.SubMenu>
        ) : (
          menu.map((modulo) => (
            <Menu.SubMenu
              key={modulo.idModulo}
              title={modulo.descripcionModulo}
            >
              {modulo.listSubModulos.map(
                ({ idSubModulo, descripcionSubModulo, pathSubModulo }) => (
                  <Menu.Item
                    key={modulo.idModulo + "|" + idSubModulo}
                    onClick={() => onMenuChange(pathSubModulo)}
                  >
                    {descripcionSubModulo}
                  </Menu.Item>
                )
              )}
            </Menu.SubMenu>
          ))
        )} */}
      </Menu>{" "}
    </Spin>
  );
};

export default withRouter(MenuAspirante);
